export { Accordion as AccordionFooter } from "./components/Accordion";
